module.exports = __webpack_public_path__ + "static/media/sonicscale-toothbrush-head-5.df53db26.jpg";